<script>
    export let rustmod;
    export let num;
    export let name;
    export let editable = true;
    let string_valid = true;

    let string_input = num.to_pretty();
    let num_input = num.to_bits();

    function update_hex(event) {
        const n = Number(event.target.value) >>> 0;
        num = rustmod.Float32.from_bits(n);
        string_input = num.to_pretty();
    }
    function update_float(event) {
        var n = rustmod.Float32.from_str(event.target.value);
        if (n !== undefined) {
            string_valid = true;
            num = n;
            num_input = n.to_bits();
        } else {
            string_valid = false;
        }
    }
    function bits(n) {
        const as_int = n.to_bits();
        return as_int.toString(2).padStart(32, "0");
    }
    function toggle_bit(n) {
        num = num.toggle_bit(n);
        string_input = num.to_pretty();
        num_input = num.to_bits();
        console.log(n);
    }
    function get_class(n) {
        if (n == 0) {
            return "sign";
        } else if (n < 9) {
            return "exponent";
        } else {
            return "mantissa";
        }
    }
</script>

<header>
    <h1>Float32 Number {name}</h1>
</header>
<div id="content">
    <h2>&nbsp;</h2>
    <h2>&nbsp;</h2>
    <table>
        {#if editable}
            <tr>
                <td>Float32 value</td>
                <td
                    ><input
                        class:field-danger={!string_valid}
                        class:field-success={string_valid}
                        type="text"
                        bind:value={string_input}
                        on:input={update_float}
                        on:change={update_float}
                    /></td
                >
            </tr>
        {/if}
        <tr><td>Stored in Float32</td><td>{num.to_float_long()}</td></tr>
        <tr><td>Precise value</td><td>{num.to_precise_long()}</td></tr>
        <tr><td>Error (Float32 - Precise)</td><td>{num.error()}</td></tr>
        <tr><td>LSB</td><td>{num.lsb()}</td></tr>
        <tr
            ><td> as uint32</td><td
                ><input
                    type="number"
                    bind:value={num_input}
                    on:input={update_hex}
                /></td
            >
        </tr>
        <tr
            ><td>Binary Representation</td>
            <td class="sem">
                <table class="sem">
                    <thead>
                        <td />
                        <td>sign</td>
                        <td colspan="8">exponent</td>
                        <td colspan="23">mantissa</td>
                    </thead>
                    <tr>
                        <td>value</td>
                        <td>{num.sign()}</td>
                        <td colspan="8">
                            2<sup
                                ><b>{num.base_exp()}</b>
                                + {num.exp() +
                                    (num.category() === "Subnormal"
                                        ? 126
                                        : 127)}</sup
                            >
                            = 2<sup>{num.exp()}</sup></td
                        >
                        <td colspan="23">
                            <b>
                                {num.base_mant()}
                            </b>
                            {#each bits(num) as bit, i}
                                {#if bit === "1" && i > 8}
                                    + 2<sup>{8 - i}</sup>
                                {/if}
                            {/each}
                            =
                            {num.mant()}
                        </td>
                    </tr>
                    <tr>
                        <td class="index">virtual index</td>
                        {#each bits(num) as _, i}
                            {#if i == 0}
                                <td class="index">0</td>
                            {:else if i <= 8}
                                <td class="index">
                                    {8 - i}
                                </td>
                            {:else}
                                <td class="index">
                                    {8 - i}
                                </td>
                            {/if}
                        {/each}
                    </tr>
                    <tr>
                        <td class="index">bit index</td>
                        {#each bits(num) as _, i}
                            <td class="index">
                                {31 - i}
                            </td>
                        {/each}
                    </tr>
                    <tr>
                        <td>bit</td>
                        {#each bits(num) as bit, i}
                            <td
                                class="{get_class(i)} bin"
                                on:click={() => toggle_bit(31 - i)}
                            >
                                {bit}
                            </td>
                        {/each}
                    </tr>
                    <tr>
                        <td>hex</td>
                        {#each num
                            .to_bits()
                            .toString(16)
                            .padStart(8, "0") as nibble}
                            <td colspan="4">{nibble}</td>
                        {/each}
                    </tr>
                </table>
            </td></tr
        >
        <tr
            ><td>class</td><td
                class={num.category() === "Normal" ? "normal" : "special"}
                >{num.category()}</td
            ></tr
        >
    </table>
</div>

<style>
    .number {
        font-size: 20px;
        float: left;
    }
    thead {
        font-weight: bold;
    }
    .reveal .slides #content div {
        text-align: left;
        font-size: 20px;
        width: 100%;
        top: 200px !important;
        padding-left: 100px;
        padding-top: 0px;
        border: 0px solid black;
    }
    table {
        border: 1px solid lightgrey;
        margin: 0 auto;
        font-size: 20px;
        width: 90%;
    }
    table.sem {
        width: 100%;
        height: 100%;
        border: 0px;
    }
    td.sem {
        padding: 0px;
    }
    td {
        cursor: default;
        border: 1px solid lightgrey;
    }
    td:nth-child(1) {
        width: 17%;
    }
    td.index {
        font-size: 14px;
        color: lightgrey;
        text-align: center;
    }
    td.sign {
        background-color: rgb(206, 196, 250);
    }
    td.exponent {
        background-color: rgb(214, 253, 251);
    }
    td.mantissa {
        background-color: rgb(255, 203, 203);
    }
    td.bin:hover {
        background-color: lightpink;
    }
    input {
        border-width: 2px;
    }
    .special {
        background-color: rgb(252, 180, 153);
    }
    .field-danger,
    .field-danger:focus {
        border-color: red;
    }
    .field-success {
        border-color: green;
    }
    @media (min-width: 640px) {
        div {
            max-width: none;
        }
    }
</style>
